import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import {
  Label,
  Input,
  Button,
  Dropdown,
  StyledRadio as Radio,
  AutoComplete,
  Checkbox,
  Datepicker,
  LoaderButton,
  NewScanner,
} from 'tigo-components';
import { CollapsibleList } from '../collapsible';
import {
  ButtonContainer,
  TextContainer,
  FormRow,
  CheckboxWrapper,
  Fieldset,
  Divider,
  InputListTitle,
  Wrapper,
  LabelLinkContainer,
  LinkLabelText,
  LinkLabel,
  ErrorIcon,
  AddNew,
  RemoveButton,
} from './styled';
import {
  isDisabled,
  validateFormFields,
  whiteSpaceFormatter,
  getFilteredOptions,
  autoResetDependencyList,
  errorValidator,
  isValidEmail,
  getISODateString,
  formatDocumentValueHN,
  getCountry,
  convertDataToFile,
} from 'utils/utils';
import { TextMaskCustom } from '../maskedInput';
import moment from 'moment';
import InputAdornment from '@material-ui/core/InputAdornment';
import InfoIcon from '@material-ui/icons/Info';
import CancelIcon from '@material-ui/icons/Cancel';
import { FormHelperText } from '@material-ui/core';
const CalendarIcon = () => <img src="/images/ico_calendar.svg" alt="calendar" />;

const emptyFn = () => {
  //default empty fn
};

const FormBuilder = ({
  formFields,
  handleSubmit,
  formData,
  updateErrorData,
  updateFormData,
  autoCompleteProps = { options: {} },
  handleCancel,
  optionalParams = [],
  calendarProps = {},
  segmentEvents,
  checkboxCallback,
  checkboxProps,
  validateOnChange = true,
  displayComponent = null,
  textFieldProps = {},
  loaderButtonProps = {},
  customTextFieldProps,
  customInputProps,
  multiCalendar,
  ...props
}) => {
  const [calendar, toggleCalendar] = useState(false);
  const [calendarList, setCalendarList] = useState({});

  const handleInputChange = (
    event,
    { inputValidations, customValidatorInput, inputDependency, inputOptionalParams, flexId, flexIndex }
  ) => {
    const {
      target: { id, value },
    } = event;
    const isError = !inputOptionalParams ? !value || errorValidator(inputValidations, value) : false;
    if (validateOnChange && validateFormFields(id, value, validateOnChange)) {
      validateOnChange && updateErrorDataFlexItem(flexIndex, id, isError);
      updateFormDataFlexItem(flexId, flexIndex, id, value);
      if (customValidatorInput && validateOnChange) {
        const _isError = customValidatorInput(formData.data, event.target.value);
        updateErrorData({ id: inputDependency, value: _isError });
      }
    } else if (validateOnChange && !validateFormFields(id, value, validateOnChange)) {
      validateOnChange && updateErrorData({ id, value: true });
      updateFormData({ [id]: value });
    } else {
      updateFormDataFlexItem(flexId, flexIndex, id, value);
      if (!isError) updateErrorDataFlexItem(flexIndex, id, false);
    }
  };

  const handleSelectChange = (event, id, customValidator, dependency) => {
    updateErrorData({ id, value: false });
    if (customValidator) {
      const isError = customValidator(formData.data, event.target.value);
      updateErrorData({ id: dependency, value: isError });
    }
    if (dependency) {
      typeof dependency !== 'string' && updateFormData({ ...autoResetDependencyList(dependency) });
    }
    if (event.target.value) updateErrorData({ id, value: false });
    updateFormData({ [id]: event.target.value });
  };

  const handleChecked = (event) => {
    const {
      target: { checked, id },
    } = event;
    updateFormData({ [id]: checked.toString() });
    if (checked.toString() === 'true') updateErrorData({ id, value: false });
    checkboxCallback(checked.toString() === 'true' ? true : false, id);
  };

  const handleBlur = (
    event,
    { inputValidations, customValidatorInput, inputDependency, inputOptionalParams, flexId, flexIndex }
  ) => {
    const {
      target: { id, value },
    } = event;

    if (id === 'email' && value && validateOnChange) {
      updateFormData({ [id]: whiteSpaceFormatter(value) });
      updateErrorData({ id, value: !isValidEmail(value) });
      !isValidEmail(value) && segmentEvents.errorEvent();
      return;
    }
    let isError = !inputOptionalParams
      ? !value || errorValidator(inputValidations, value)
      : !value
        ? false
        : errorValidator(inputValidations, value);
    isError = isError || !validateFormFields(id, value, validateOnChange);
    isError && segmentEvents.errorEvent();
    updateFormDataFlexItem(flexId, flexIndex, id, whiteSpaceFormatter(value));
    validateOnChange && updateErrorDataFlexItem(flexIndex, id, isError);
    if (customValidatorInput) {
      const _isError = customValidatorInput(formData.data, event.target.value);
      validateOnChange && updateErrorData({ id: inputDependency, value: _isError });
      _isError && segmentEvents.errorEvent();
    }
  };

  const disabled = (validateOnChange) => {
    if (!validateOnChange) return false;
    if (formData.errors) return Object.values(formData.errors).some((value) => value === true);
    return false;
  };

  const handleAutoComplete = (id, e, option, dependency, flexId, flexIndex) => {
    const customOption = option || '';
    if (dependency) {
      updateFormData({ ...autoResetDependencyList(dependency) });
    }
    updateFormDataFlexItem(flexId, flexIndex, id, customOption);
    updateErrorDataFlexItem(flexIndex, id, false);
  };

  const setSelectedDate = (value, id, validate) => {
    if (calendarProps.availableDays && calendarProps.availableDays.length) {
      if (calendarProps.availableDays.includes(moment(value).format('DD/MM/YYYY'))) {
        updateFormData({ [id]: value });
      } else {
        updateFormData({
          [id]: getISODateString(calendarProps.availableDays[0]),
        });
      }
    } else {
      updateFormData({ [id]: value });
    }
    if (validate && value) {
      updateErrorData({ id, value: false });
    }
  };

  const getAutoCompleteError = (error, validateOnChange) => {
    if (error && !validateOnChange) {
      return { error: true };
    }
    return {};
  };

  const addNewFlexibleItem = (id, keyId, valueId) => {
    const data = formData.data[id];
    updateFormData({ [id]: [...data, { [keyId]: '', [valueId]: '' }] });
  };

  const removeFlexibleItem = (id, keyId, valueId, index) => {
    const data = formData.data[id];
    updateFormData({ [id]: [...data.slice(0, index), ...data.slice(index + 1)] });
    updateErrorData({ id: `${keyId}${index}`, value: false });
    updateErrorData({ id: `${valueId}${index}`, value: false });
  };

  const updateFormDataFlexItem = (flexId, flexIndex, id, value) => {
    if (flexId) {
      let newFlexArray = [...formData.data[flexId]];
      newFlexArray[flexIndex][id] = value;
      updateFormData({ [flexId]: newFlexArray });
    } else {
      updateFormData({ [id]: value });
    }
  };

  const updateErrorDataFlexItem = (flexIndex, id, error) => {
    if (flexIndex !== undefined) {
      updateErrorData({ id: `${id}${flexIndex}`, value: error });
    } else {
      updateErrorData({ id, value: error });
    }
  };

  const flexItemData = (flexId, flexIndex, id) => (flexId ? formData.data[flexId][flexIndex][id] : formData.data[id]);

  const flexItemError = (flexIndex, id) =>
    flexIndex !== undefined ? formData.errors[`${id}${flexIndex}`] : formData.errors[id];
  const setInputProps = (fieldMask, error, validateOnChange, id) => {
    let inputProp = {};
    const country = getCountry();
    const ErrorDisplayIcon = country === 'CO' ? InfoIcon : CancelIcon;
    const CustomInputAdornments = props?.CustomInputAdornments || null;
    if (fieldMask) inputProp = { ...inputProp, inputComponent: TextMaskCustom };
    if (error && !validateOnChange)
      inputProp = {
        ...inputProp,
        endAdornment: (
          <InputAdornment>
            <ErrorIcon>
              <ErrorDisplayIcon />
            </ErrorIcon>
          </InputAdornment>
        ),
      };
    if (CustomInputAdornments && !error) inputProp = { ...inputProp, endAdornment: CustomInputAdornments?.[id] };
    return inputProp;
  };

  const generateFormField = (formField) => {
    return formField.map((field, index) => {
      const { id, text } = field;
      const { flexId, flexIndex } = field.flexibleConfig || { flexId: undefined, flexIndex: undefined };
      const data = formData.data[id];
      switch (field.type) {
        case 'text':
        case 'tel':
        case 'textarea':
          const {
            flexSpan,
            mask,
            customValidator: customValidatorInput,
            validations: inputValidations,
            dependency: inputDependency,
            optional: inputOptionalParams,
            helperText,
            disabled: inputDisabled,
            uppercase = false,
            ...inputFieldParams
          } = field;
          const fieldMask = mask ? (typeof mask === 'boolean' ? mask : mask(formData.data)) : false;
          const customTextProps = textFieldProps?.[field.id] || {};
          return (
            <div style={{ width: '100%' }} className={field.className || 'inputDiv'}>
              <Input
                key={field.id}
                onChange={(e) =>
                  handleInputChange(e, {
                    inputValidations,
                    customValidatorInput,
                    inputDependency,
                    inputOptionalParams,
                    flexId,
                    flexIndex,
                  })
                }
                onBlur={(e) => {
                  if (customInputProps?.[id]?.onBlur) customInputProps[id].onBlur(e);
                  handleBlur(e, {
                    inputValidations,
                    customValidatorInput,
                    inputDependency,
                    inputOptionalParams,
                    flexId,
                    flexIndex,
                  });
                }}
                value={
                  uppercase
                    ? `${flexItemData(flexId, flexIndex, id)}`.toUpperCase()
                    : flexItemData(flexId, flexIndex, id)
                }
                error={flexItemError(flexIndex, id)}
                InputProps={setInputProps(fieldMask, flexItemError(flexIndex, id), validateOnChange, field.id)}
                helperText={typeof helperText === 'function' ? helperText(data, formData.errors[id]) : helperText}
                disabled={
                  inputDisabled
                    ? true
                    : field.flexDisabled && flexId && !flexItemData(flexId, flexIndex, field.flexibleConfig.flexKeyId)
                      ? true
                      : false
                }
                {...inputFieldParams}
                {...customTextProps}
              />
            </div>
          );
        case 'select':
          const {
            customValidator,
            dependency: objDependency,
            helperText: dropDownHelperText,
            ...dropdownConfig
          } = field;

          const textDisplay =
            typeof dropDownHelperText === 'function'
              ? dropDownHelperText(data, formData.errors[id])
              : dropDownHelperText;

          return (
            <React.Fragment>
              <Dropdown
                key={index}
                options={field.options}
                onChange={(e) => handleSelectChange(e, id, customValidator, objDependency)}
                value={data}
                error={formData.errors[id]}
                {...dropdownConfig}
              />
              <FormHelperText style={{ marginTop: textDisplay ? '-8px' : '', color: '#f44336' }}>
                {textDisplay}
              </FormHelperText>
            </React.Fragment>
          );
        case 'collapsibleList':
          return (
            <div style={{ margin: '10px 0px' }} key={field.label} data-label={field.label || field.name}>
              <CollapsibleList
                label={field.label}
                value={flexItemData(flexId, flexIndex, id)}
                multiLabel={field?.multiLabel || false}
                listitems={field.options.map((item) => item.label)}
                options={field.options}
                onClick={(value) => {
                  if (customInputProps?.[id]?.onClick) customInputProps[id].onClick();
                  updateFormDataFlexItem(flexId, flexIndex, id, formatDocumentValueHN(value));
                }}
                disabled={field.disabled}
              />
            </div>
          );
        case 'label':
          return (
            <TextContainer key={index} className={[field.className && field.className]}>
              <Label text={text} {...field} />
            </TextContainer>
          );
        case 'formRow':
          const classNameProp = field?.className || '';
          return (
            <FormRow key={index} className={`form-row ${classNameProp}`}>
              {field.components.map((c, i) => (
                <div
                  key={i}
                  style={{ flex: c.flexSpan, marginRight: c.marginRight, marginLeft: c.marginLeft, width: c.width }}
                  className={c?.className || ''}
                >
                  {generateFormField(c.component)}
                </div>
              ))}
            </FormRow>
          );
        case 'flexibleFormRow':
          return (
            <>
              {data.map((_, index) => {
                const flexibleConfig = {
                  flexId: id,
                  flexIndex: index,
                  flexKeyId: field.keyId,
                  flexValueId: field.valueId,
                };
                field.components.forEach((c) => {
                  c.component[0]['flexibleConfig'] = flexibleConfig;
                });
                return (
                  <FormRow key={index}>
                    {index > 0 && (
                      <RemoveButton onClick={() => removeFlexibleItem(id, field.keyId, field.valueId, index)} />
                    )}
                    {field.components.map((c, i) => (
                      <div key={i} style={{ flex: c.flexSpan, marginRight: c.marginRight, marginLeft: c.marginLeft }}>
                        {generateFormField(c.component)}
                      </div>
                    ))}
                  </FormRow>
                );
              })}
              <AddNew onClick={() => addNewFlexibleItem(id, field.keyId, field.valueId)} />
            </>
          );
        case 'button':
          const { setButtonText = false, className = '', ...buttonProps } = field;
          return (
            <ButtonContainer key={index} align={buttonProps.alignSelf} className={className || ''}>
              <Button
                onClick={() => {
                  if (props.resetFields && props.resetFields.length) {
                    props.resetFields.forEach((item) => updateFormData({ [item.id]: item.value }));
                  }
                  if (setButtonText) handleSubmit({ ...formData.data, selectedButtonText: field.text });
                  else handleSubmit({ ...formData.data });
                }}
                disabled={
                  isDisabled(formData.data, optionalParams, validateOnChange) ||
                  disabled(validateOnChange) ||
                  props.disableButton
                }
                text={text}
                {...buttonProps}
              />
            </ButtonContainer>
          );
        case 'radio':
          return (
            <Radio
              key={index}
              options={field.options}
              handleChange={(e) => handleSelectChange(e, id, field.customValidator, field.dependency)}
              selected={formData.data[id]}
              displayComponent={displayComponent}
            />
          );
        case 'checkbox':
          return (
            <CheckboxWrapper key={index} className={field.className || ''}>
              <Checkbox onChange={handleChecked} {...field} {...(checkboxProps[id] ?? checkboxProps)} />
            </CheckboxWrapper>
          );
        case 'autocomplete':
          const { options, dependency, helperText: autocompleteHelperText = '', optionsOffset = '', ...rest } = field;
          const customPropsForId = autoCompleteProps?.customProps?.[field.id] || {};
          return (
            <AutoComplete
              key={index}
              options={
                autoCompleteProps?.options?.[field?.id] || getFilteredOptions(options, field?.id, formData?.data) || []
              }
              optionsOffset={flexIndex && flexIndex > 0 ? optionsOffset : ''}
              onChange={(e, option) => {
                handleAutoComplete(field.id, e, option, dependency, flexId, flexIndex);
                if (autoCompleteProps?.customProps?.[field.id]?.onChange) {
                  const customOnChange = autoCompleteProps?.customProps?.[field.id]?.onChange;
                  customOnChange();
                }
              }}
              onBlur={(e) => {
                if (autoCompleteProps?.customProps?.[field.id]?.onBlur) {
                  const onBlur = autoCompleteProps?.customProps?.[field.id]?.onBlur;
                  onBlur();
                }
              }}
              value={flexItemData(flexId, flexIndex, id)}
              textFieldProps={{
                ...getAutoCompleteError(flexItemError(flexIndex, id), validateOnChange),
                ...customTextFieldProps,
              }}
              helperText={
                typeof autocompleteHelperText === 'function'
                  ? autocompleteHelperText(data, formData.errors[id])
                  : autocompleteHelperText
              }
              disabled={field.disabled}
              {...customPropsForId}
              {...rest}
            />
          );
        case 'button-group':
          return (
            <ButtonContainer key={index} className={`${field?.className || ''} formbuilder-btn-group`}>
              {field.buttons.map((btn, index) => {
                return (
                  <Button
                    key={index}
                    onClick={() => {
                      if (btn.type === 'cancel') handleCancel();
                      else {
                        if (btn.setButtonText) handleSubmit({ ...formData.data, selectedButtonText: btn.text });
                        else handleSubmit({ ...formData.data });
                      }
                    }}
                    disabled={isDisabled(formData.data, optionalParams, validateOnChange) || disabled(validateOnChange)}
                    {...btn}
                  />
                );
              })}
            </ButtonContainer>
          );

        case 'inputList':
          return (
            <Fieldset key={index}>
              <Divider />
              <InputListTitle>{field.title}</InputListTitle>
              {generateFormField(field.options)}
            </Fieldset>
          );
        case 'divider':
          return (
            <div className="divider">
              <Divider key={index} />
            </div>
          );
        case 'date':
          const customCalendarProps = field.calendarProps || {};
          return (
            <Datepicker
              key={field.id}
              onChange={(value) => {
                const customOnChange = calendarProps?.[field.id]?.onChange;
                customOnChange && customOnChange();
                setSelectedDate(value, field.id, customCalendarProps.validate);
              }}
              value={data || null}
              label={field.label}
              error={formData.errors[id]}
              placeholder={field.placeholder}
              disablePast={field.disablePast}
              open={calendarList?.[field.id] || calendar}
              onClose={() => {
                if (multiCalendar) setCalendarList({ [field.id]: false });
                else toggleCalendar(false);
              }}
              disabled={field.disabled || false}
              onClick={() => {
                if (multiCalendar) {
                  if (!calendarList?.[field.id]) {
                    setCalendarList({ [field.id]: true });
                  }
                } else {
                  if (!calendar) {
                    toggleCalendar(true);
                  }
                }
              }}
              keyboardIcon={<CalendarIcon />}
              {...customCalendarProps}
              {...calendarProps}
            />
          );
        case 'linkWithLabel':
          return (
            <LabelLinkContainer key={index} className={field.className || 'label_link_wrp'}>
              {field.label && <LinkLabelText> {field.label} </LinkLabelText>}
              {field.link && (
                <LinkLabel className="ext-link" onClick={() => window.open(field.externalLink, '_blank')}>
                  {field.link}
                </LinkLabel>
              )}
              {field.labelAfterLink && <LinkLabelText> {field.labelAfterLink} </LinkLabelText>}
            </LabelLinkContainer>
          );
        case 'buttonLoader':
          return (
            <ButtonContainer key={index} align={field.alignSelf}>
              <LoaderButton
                onClick={() => {
                  if (props.resetFields && props.resetFields.length) {
                    props.resetFields.forEach((item) => updateFormData({ [item.id]: item.value }));
                  }
                  handleSubmit({ ...formData.data });
                }}
                disabled={
                  isDisabled(formData.data, optionalParams, validateOnChange) ||
                  disabled(validateOnChange) ||
                  props.disableButton
                }
                {...field}
                {...loaderButtonProps}
              />
            </ButtonContainer>
          );
        case 'nativedate':
          const cProps = field.calendarProps || {};
          return (
            <TextField
              key={field.id}
              type="date"
              variant="outlined"
              onChange={(event) => {
                const customOnChange = calendarProps?.[field.id]?.onChange;
                customOnChange && customOnChange();
                setSelectedDate(event.target.value, field.id, cProps.validate);
              }}
              value={data || null}
              label={field.label}
              error={formData.errors[id]}
              classes={{ root: data ? 'valid-date' : '' }}
              inputProps={{ ...field.inputProps }}
              {...cProps}
              {...calendarProps}
            />
          );
        case 'scanner':
          return (
            <>
              {field.isMobile ? (
                <CheckboxWrapper key={index} className={field.className || ''}>
                  <Checkbox checked={field.checked} onChange={field.onChange} label={field.label} />
                </CheckboxWrapper>
              ) : null}
              <div key={`${Math.random()}-${index}`}>
                <NewScanner
                  filePath={field?.fileName}
                  upload={field?.isUpload}
                  getImage={(data) => field.getImageFunc(data)}
                  convertDataToFile={convertDataToFile}
                  loaderFunc={() => field?.loaderFunc()}
                  btnText={field?.btnText || 'Cargar foto'}
                  {...field?.scannerConfig}
                />
              </div>
            </>
          );

        default:
          return null;
      }
    });
  };

  return <Wrapper>{formFields.length ? generateFormField(formFields) : null}</Wrapper>;
};

FormBuilder.defaultProps = {
  handleCancel: emptyFn,
  segmentEvents: { errorEvent: emptyFn },
  checkboxCallback: emptyFn,
  checkboxProps: {},
  validateOnChange: true,
  displayComponent: null,
  customInputProps: {},
  customTextFieldProps: {},
  multiCalendar: false,
};

export default FormBuilder;
